import React, { Dispatch, SetStateAction } from 'react';
import { Nullable } from 'global';
import { FinanceFilters, FinanceFilterType, FinanceFiltersContainer } from 'modules/finance/filters';
import { FilterEvent } from 'components/shared/Filters';

interface Props {
  isFiltersOpen: boolean;
  currentFilterConfig: Nullable<Partial<FinanceFilters>>;
  setIsFiltersOpen: Dispatch<SetStateAction<boolean>>;
  onTableFiltersChanged: (filters: Partial<FinanceFilters>, event: FilterEvent) => void;
}

// Finance page filters: Deal Date (date range), Sales Rep, Location/Branch
const FINANCE_PAGE_FILTERS: FinanceFilterType[] = [
  FinanceFilterType.DEAL_DATE,
  FinanceFilterType.SALES_REP,
  FinanceFilterType.LOCATION,
];

export const FinanceTableFilters = ({
  isFiltersOpen,
  currentFilterConfig,
  setIsFiltersOpen,
  onTableFiltersChanged,
}: Props) => {
  return (
    <FinanceFiltersContainer
      open={isFiltersOpen}
      onClose={() => setIsFiltersOpen(false)}
      onChanged={onTableFiltersChanged}
      externalMeta={{}}
      configuration={FINANCE_PAGE_FILTERS}
      externalFiltersValue={currentFilterConfig}
    />
  );
};
